import React from "react"
import autobind from "class-autobind"
import { IScheduleDailyTimelineData, ISimpleTime } from "../../../models"
import TimelineItem from "./TimelineItem"
interface IProps {
  width: number
  widthPerHour: number
  timelineBarHourLength: number
  coordinateTime: ISimpleTime
  item: any
  dailyData: IScheduleDailyTimelineData[]
  selected: boolean
  rowNumber: number
  readonly: boolean
  handleUpdate(item: any): void
  timelineItemRenderElement(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): JSX.Element
  handleUpdateTimelineData(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): void
  checkValidateNewTimeline?(timelineItem: IScheduleDailyTimelineData, rowNumber: number, orderNumber: number): boolean
  handleShowPopup(popupX: number, popupY: number, rowNumber: number, orderNumber: number): void
  handleHidePopup(): void

  // allow to edit by Tab
  allowQuickEditTime?: boolean
  quickEditTimeRowNumber?: number
  quickEditTimeOrderNumber?: number
  handleSelectQuickEditTimeRow?(rowNumber: number, orderNumber: number): void
}
interface IState {
  effectMouseClick: boolean
}

export default class TimelineTableRightSideHorizontalRow extends React.Component<IProps, IState> {
  private TimelineItem = []
  constructor(props) {
    super(props)
    this.state = {
      effectMouseClick: false,
    }
    autobind(this)
  }

  render() {
    return (
      <div
        style={{
          position: "absolute",
          width: this.props.width - 2,
          left: 0,
          height: this.props.rowNumber === 0 ? 50 : 51,
          top: 0,
          backgroundColor: this.props.selected && "rgb(224, 224, 224)"
        }}
        onMouseDown={() => !this.props.readonly && this.setState({ effectMouseClick: true })}
        onMouseUp={() => {
          if (this.props.readonly) return
          this.setState({ effectMouseClick: false })
          this.state.effectMouseClick && this.props.handleUpdate && this.props.handleUpdate(this.props.item)
        }}
      >
        {this.props.dailyData.map((item, index) =>
          <TimelineItem
            ref={i => this.TimelineItem[index] = i}
            key={index}
            rowNumber={this.props.rowNumber}
            orderNumber={index}
            timelineItem={item}
            widthPerHour={this.props.widthPerHour}
            timelineBarHourLength={this.props.timelineBarHourLength}
            coordinateTime={this.props.coordinateTime}
            timelineItemRenderElement={this.props.timelineItemRenderElement}
            handleUpdateTimelineData={this.props.handleUpdateTimelineData}
            checkValidateNewTimeline={this.props.checkValidateNewTimeline}
            handleShowPopup={this.props.handleShowPopup}
            handleHidePopup={this.props.handleHidePopup}
            readonly={this.props.readonly}

            quickEditTime={this.props.rowNumber === this.props.quickEditTimeRowNumber && index === this.props.quickEditTimeOrderNumber}
            handleSelectQuickEditTimeItem={this.props.handleSelectQuickEditTimeRow}
          />
        )}
      </div>
    )
  }
}